var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('Head',{attrs:{"order":_vm.order}}),_c('Customer',{attrs:{"order":_vm.order}}),_c('Footer',{attrs:{"order":_vm.order}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }